package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.ChatBubbleW500Rounded: ImageVector
    get() {
        if (_chatBubbleW500Rounded != null) {
            return _chatBubbleW500Rounded!!
        }
        _chatBubbleW500Rounded = Builder(name = "ChatBubbleW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveToRelative(231.87f, 728.13f)
                lineToRelative(-82.44f, 82.44f)
                quadToRelative(-21.63f, 21.63f, -49.59f, 9.77f)
                quadToRelative(-27.97f, -11.86f, -27.97f, -42.36f)
                verticalLineToRelative(-615.11f)
                quadToRelative(0.0f, -37.78f, 26.61f, -64.39f)
                reflectiveQuadToRelative(64.39f, -26.61f)
                horizontalLineToRelative(634.26f)
                quadToRelative(37.78f, 0.0f, 64.39f, 26.61f)
                reflectiveQuadToRelative(26.61f, 64.39f)
                verticalLineToRelative(474.26f)
                quadToRelative(0.0f, 37.78f, -26.61f, 64.39f)
                reflectiveQuadToRelative(-64.39f, 26.61f)
                lineTo(231.87f, 728.13f)
                close()
                moveTo(197.87f, 637.13f)
                horizontalLineToRelative(599.26f)
                verticalLineToRelative(-474.26f)
                lineTo(162.87f, 162.87f)
                verticalLineToRelative(508.5f)
                lineToRelative(35.0f, -34.24f)
                close()
                moveTo(162.87f, 637.13f)
                verticalLineToRelative(-474.26f)
                verticalLineToRelative(474.26f)
                close()
            }
        }
        .build()
        return _chatBubbleW500Rounded!!
    }

private var _chatBubbleW500Rounded: ImageVector? = null
